import { Box } from "@mui/material";
import Footer from "./Footer";
import IotDetekceVypnutaBanner from "./iot/IotDetekceVypnutaBanner";
import { ReactNode } from "react";

interface LayoutProps {
    children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <Box
            sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}
        >
            <IotDetekceVypnutaBanner />
            <Box sx={{ flex: '1 1 auto', overflow: 'auto', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                {children}
            </Box>
            <Footer />
        </Box>
    );
};


export default Layout;